import { render, staticRenderFns } from "./EdTekyeDestination.vue?vue&type=template&id=7295dbec&"
import script from "./EdTekyeDestination.vue?vue&type=script&lang=js&"
export * from "./EdTekyeDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports